import script from "./our-project2.vue?vue&type=script&setup=true&lang=js"
export * from "./our-project2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__